import PropTypes from 'prop-types'
import React from 'react'
import { Icon, Spin } from 'antd'

function CustomSpin(props) {
  return <Spin {...props}>{props.children}</Spin>
}

CustomSpin.defaultProps = {
  spinning: false,
}

CustomSpin.propTypes = {
  spinning: PropTypes.any,
}

export default CustomSpin
